import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import cx from 'classnames';
import { TablePagination } from '@material-ui/core';
import PopupDialog from 'ui/components/popup-dialog';
import { useSelector, useDispatch } from 'react-redux';
import { setBillboardTypeList } from '../../redux/app';
import DataTable from '../ui/table';
import ModalDialog from '../ui/modal-dialog';
import BillboardTypeEdit from './billboard-type-edit';
import { deleteBillboardTypeAPI, getBillboardTypeList } from '../../api/settingAPI';
var t = i18n.getFixedT(null, 'setting-billboard');
var gt = i18n.getFixedT(null, 'app');
var BillboardTypeSetting = /*#__PURE__*/React.memo(function (_ref) {
  var id = _ref.id,
      handleIsModified = _ref.handleIsModified,
      onClose = _ref.onClose;

  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      billboardTypeList = _useSelector.app.billboardTypeList;

  var dispatch = useDispatch();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(10),
      _useState6 = _slicedToArray(_useState5, 2),
      rowsPerPage = _useState6[0],
      setRowsPerPage = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openTypeDialog = _useState8[0],
      setOpenTypeDialog = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      mode = _useState10[0],
      setMode = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      currentEditType = _useState12[0],
      setCurrentEditType = _useState12[1];

  var totalCount = billboardTypeList.length;
  var tableData = billboardTypeList.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage);

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  var handleDelete = function handleDelete(typeId) {
    // eslint-disable-next-line no-shadow
    PopupDialog.confirm({
      title: t('dlg-billboard-type-setting-delete'),
      display: t('text-delete-billboard-type'),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          deleteBillboardTypeAPI(contextRoot, false, typeId).then(function () {
            getBillboardTypeList(contextRoot, true).then(function (result) {
              var newList = _.map(result.content, function (el) {
                return {
                  value: _.trim(el.id),
                  text: el.name
                };
              });

              dispatch(setBillboardTypeList(newList));
              setError(null);
            });
            handleIsModified(true);
          });
        }
      }
    });
  }; // eslint-disable-next-line no-shadow


  var handleOpenDialog = function handleOpenDialog(mode, typeId) {
    // setCurrentEditType(mode === 'edit' ? typeId : null)
    if (mode === 'create') {
      setMode('create');
      setOpenTypeDialog(true);
      setCurrentEditType(null);
    } else {
      var typeData = _.find(billboardTypeList, function (item) {
        return item.value === typeId;
      });

      if (typeData) {
        setMode('edit');
        setCurrentEditType(_objectSpread({}, typeData));
        setOpenTypeDialog(true);
      }
    }
  };

  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: function handler() {
      if (onClose) {
        onClose();
      }
    }
  });

  var fields = {};

  _.set(fields, 'text', {
    label: t('lbl-type'),
    formatter: function formatter(val) {
      return /*#__PURE__*/React.createElement("p", {
        style: {
          minWidth: '300px',
          margin: '0'
        }
      }, val);
    }
  });

  _.set(fields, 'more', {
    label: t('lbl-more'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, /*#__PURE__*/React.createElement("a", {
        title: t('lbl-edit'),
        onClick: function onClick() {
          return handleOpenDialog('edit', row.value);
        },
        className: "edit"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-pencil-alt fa-list-alt"
      })), /*#__PURE__*/React.createElement("a", {
        title: t('lbl-delete'),
        onClick: function onClick() {
          return handleDelete(row.value);
        },
        className: "delete"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-trash"
      })));
    }
  });

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('dlg-billboard-type-setting'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "bar"
  }, /*#__PURE__*/React.createElement("a", {
    className: "create-billboard-btn",
    onClick: function onClick() {
      return handleOpenDialog('create');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    rowIdField: "value"
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }))), openTypeDialog && /*#__PURE__*/React.createElement(BillboardTypeEdit, {
    id: "g-billboard-edit-".concat(mode),
    mode: mode,
    currentEditType: currentEditType,
    handleIsModified: handleIsModified,
    onClose: function onClose() {
      return setOpenTypeDialog(false);
    }
  }));
});
BillboardTypeSetting.defaultProps = {
  id: 'g-billboard-edit'
};
BillboardTypeSetting.propTypes = {
  id: PropTypes.string,
  handleIsModified: PropTypes.func,
  onClose: PropTypes.func
};
export default BillboardTypeSetting;